export default {
  home: 'Accueil', 
  contact: 'Contactez-nous',
  btnCreateAccount: 'Créer mon compte',
};
